import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'lp-whatsapp',
  templateUrl: './lp-whatsapp.component.html',
  styleUrls: ['./lp-whatsapp.component.scss']
})
export class LpWhatsappComponent implements OnInit{
  
  public lp:any           = null;
  public configuracao:any = null;

  constructor(
    public storage: DataService,
    public router: Router
  ){}
    
  /**
   * 
   * Open
   * 
   */
  open(){

    if(this.lp.whatsapp_tipo == 2){
      
      let phone = this.lp.whatsapp;
      phone  = "55"+phone.replace("(","").replace(")","").replace("-","").replace(" ","");
      
      window.open("https://api.whatsapp.com/send?phone="+phone,"__blank");
      return false;
    
    }else{

      let phone = this.configuracao.whatsapp;
      
      phone  = "55"+phone.replace("(","").replace(")","").replace("-","").replace(" ","");
      
      window.open("https://api.whatsapp.com/send?phone="+phone,"__blank");
      return false;

    }

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit(): void {
    this.lp           = this.storage.getLp();
    this.configuracao = this.storage.getConfiguracao();
  }

}
